<template>

  <v-container fluid>

    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="progress_dialog" width="400px">
        <v-row justify="center">
          <v-col cols="2">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
              />
          </v-col>
        </v-row>
        <v-row justify="center">
            <label>{{$t("adminnotice_label7")}}</label>
        </v-row>
      </v-dialog>  
    </v-row>    

    <v-row dense>

      <v-col cols="12" md="5" sm="12" xs="12" class="pa-0">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <v-col cols="12" md="3" class="pa-0">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          hide-details
          />
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
      </v-col>        
  </v-row>
  
  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        v-model="selected"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        item-class="itemstyle"
        >
        <template v-slot:header.IDX>
          <a :class="sort_name=='IDX'?'cheader_sortselect':'cheader_sort'" @click="customsort('IDX')">{{$t("adminnotice_col1")}}</a>
        </template>
        <template v-slot:header.TITLE>
          <a :class="sort_name=='TITLE'?'cheader_sortselect':'cheader_sort'" @click="customsort('TITLE')">{{$t("adminnotice_col2")}}</a>
        </template>
        <template v-slot:header.TYPE_NAME>
          <a :class="sort_name=='TYPE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('TYPE_NAME')">{{$t("adminnotice_col3")}}</a>
        </template>
        <template v-slot:header.FIX>
          <label class="cheader_normal" >{{$t("adminnotice_col4")}}</label>
        </template>
        <template v-slot:header.UP_DATE>
          <a :class="sort_name=='UP_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('UP_DATE')">{{$t("adminnotice_col5")}}</a>
        </template>
        <template v-slot:header.REG_DATE>
          <a :class="sort_name=='REG_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('REG_DATE')">{{$t("adminnotice_col6")}}</a>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("adminnotice_col7")}}</label>
        </template>

        <template v-slot:item.TITLE="{ item }">  
          <a @click="loadnotice(item)" >{{item.TITLE}}</a>
        </template>
        <template v-slot:item.FIX="{ item }">  
          <template v-if="item.FIX == 1">
            <label style="color:green;text-align:center">{{$t("adminnotice_label3")}}</label>
          </template>
          <template v-else>
            <label style="color:red;text-align:center">{{$t("adminnotice_label9")}}</label>
          </template>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10"  icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red"  icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn  icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10"  icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  </v-container>
</template>

<script>
export default {

    data: () => ({

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,        //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      dialog2:false,
      progress_dialog:false,
      defaultItem: {
          IDX:0,
          TITLE:'',
          DESC:'',
          TYPE:0,
          FIX:0,
          FILE1:'',
          FILE2:'',
          FILE3:'',
      },
      editedItem: {
      },
      selected:[],              //테이블에 선택된 아이템 리스트

      //테이블 정의
      headers: [
        {text: '번호', value: 'IDX', sortable: false, align:'center', width:'100px'},
        {text: '제목', value: 'TITLE', sortable: false, align:'left', width:'320px'},
        {text: '등록일시', value: 'REG_DATE', sortable: false, align:'center' , width:'200px'},
      ],
      itemList: [],

      sort_name: 'REG_DATE',
      sort_type: true,    //true : DESC, false: ASC

      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    

    }),


    beforeDestroy() {
    },

    mounted(){

      if(this.$session.get("GRADE") < 99){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }

    },

    create(){
      
    },

    methods: {

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/ComNoticeList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                this.itemList.splice(0, this.itemList.length);   //데이터 초기화
                list.forEach(element => {
                    if(element.FILE1 != undefined && element.FILE1 != null && element.FILE1.length > 0){
                      const last = element.FILE1.split("/")
                      element.FILENAME =  decodeURI(last[last.length-1]);
                    }else{
                      element.FILENAME = "";
                    }
                    this.itemList.push(element); 
                });

                this.loading = false;

            }else if(result.data.resultCode == 2){

              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
              
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage(1);
      },      

      //검색
      search_run(){
        this.loadpage(1);
      },
      
      //게시글 상세보기
      loadnotice(item){
        this.$router.push({path:"NoticeDetail", query:{NOTICE_IDX:item.IDX}});
      },


    },
  
}
</script>

<style lang="css">
  td{
    height: 36px !important;
  }
</style>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>